export enum ProductPackagesType {
	ALL = 'all',
	PACKAGE = 'package',
	NON_PACKAGE = 'non_package',
}

export const ProductPackagesTypeTranslate = {
	[ProductPackagesType.ALL]: 'Все продукты',
	[ProductPackagesType.PACKAGE]: 'Только пакеты услуг',
	[ProductPackagesType.NON_PACKAGE]: 'Не пакеты услуг',
}
